module.exports = __webpack_public_path__ + "media/Video 93.76b934da.mp4";